import React, { useEffect, useRef, useState } from "react";
import GIVFHeroSection from "../components/givf/GIVFHeroSection";
import MeetCoraaSection from "../components/givf/MeetCoraaSection";
import PlanCampaignSection from "../components/givf/PlanCampaignSection";
import EventCarouselSection from "../components/givf/EventCarouselSection";
import PartnerLogosSection from "../components/givf/PartnerLogosSection";
import { Footer } from "../components/Footer";
import { CookieConsent } from "../components/CookieConsent";
import SEO from "../components/SEO";
import { Helmet } from "react-helmet-async";
import CoraaAIDialog from "../components/givf/CoraaAIDialog";

// Placeholder images and logos, replace with real assets
// Unsplash stock images and illustrations
const cityMap =
  "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80"; // India map illustration or city skyline
const collage =
  "https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=600&q=80"; // Volunteers collage
const nonprofitBenefitsImg =
  "https://images.unsplash.com/photo-1503676382389-4809596d5290?auto=format&fit=crop&w=600&q=80"; // Nonprofit teamwork
const heroIllustration =
  "https://undraw.co/api/illustrations/undraw_team_spirit_hrr4.svg"; // Illustration from unDraw
const partnerLogos = [
  "https://upload.wikimedia.org/wikipedia/commons/4/44/CORAA_logo.svg",
  "https://upload.wikimedia.org/wikipedia/commons/4/4a/Logo_2013_Google.png",
  "https://upload.wikimedia.org/wikipedia/commons/0/08/Microsoft_logo_%282012%29.svg",
  // ...add more
];

// Dummy event data for the GIVF event carousel
const eventCarouselData = [
  {
    image: "/images/events/resume-mentorship.jpg",
    title: "Resume Writing Mentorship",
    location: "Virtual",
    duration: "90 mins",
    volunteers: "50-100",
    description:
      "Well-written resumes improve interview call-back rates by 40%. Mentorship in writing resumes helps job seekers articulate skills, especially for first-gen professionals.",
    price: "INR 300 per volunteer",
    availability: "Available in 7 locations",
  },
  {
    image: "/images/events/crossword-creators.jpg",
    title: "Science Crossword Creators",
    location: "In-Office",
    duration: "90 mins",
    volunteers: "50-100",
    description:
      "Integrating science content into puzzles reinforces learning through gamification—a method shown by Edutopia to improve academic engagement by 17%.",
    price: "INR 525 per volunteer",
    availability: "Available in 7 locations",
  },
  {
    image: "/images/events/skill-up.jpg",
    title: "Skill Up: Career Readiness Series",
    location: "In-Office",
    duration: "90 mins",
    volunteers: "50-100",
    description:
      "Skill development is essential for youth employability and long-term economic stability. This series offers practical, hands-on upskilling workshops.",
    price: "INR 600 per volunteer",
    availability: "Available in 7 locations",
  },
  {
    image: "/images/events/study-corner.jpg",
    title: "Decorate a Study Corner for a Child",
    location: "In-Office",
    duration: "90 mins",
    volunteers: "50-100",
    description:
      "Many children in underserved homes lack dedicated, inspiring learning environments. Enhancing their study space fosters focus and ownership.",
    price: "INR 1200 per volunteer",
    availability: "Available in 7 locations",
  },
  {
    image: "/images/events/play-spaces.jpg",
    title: "Design Sustainable Play Spaces",
    location: "Outdoor",
    duration: "90 mins",
    volunteers: "50-100",
    description:
      "Recycled-material playscapes provide both physical activity and eco-education, especially in urban slums and rural schools.",
    price: "INR 1150 per volunteer",
    availability: "Available in 7 locations",
  },
  {
    image: "/images/events/digital-declutter.jpg",
    title: "Digital Declutter Day",
    location: "Virtual",
    duration: "90 mins",
    volunteers: "50-200",
    description:
      "Unused digital data and clutter in email and cloud storage contribute to energy consumption and decreased productivity. Streamline digital storage and boost efficiency!",
    price: "INR 10000 per event",
    availability: "Available in 7 locations",
  },
  {
    image: "/images/events/hygiene-pack.jpg",
    title: "Personal Hygiene Pack Drive",
    location: "In-Office",
    duration: "90 mins",
    volunteers: "50-100",
    description:
      "Poor personal hygiene contributes to significant morbidity rates, especially in children. This drive helps provide essential hygiene kits.",
    price: "INR 1300 per volunteer",
    availability: "Available in 7 locations",
  },
  {
    image: "/images/events/quiz-science.jpg",
    title: "Quiz IT: Science Edition",
    location: "In-Office",
    duration: "90 mins",
    volunteers: "50-100",
    description:
      "Competitive quizzing fosters both motivation and improved understanding in STEM subjects. This initiative increases positive attitudes towards science.",
    price: "INR 525 per volunteer",
    availability: "Available in 7 locations",
  },
  {
    image: "/images/events/skill-resume.jpg",
    title: "Ready for Work: Skill & Resume Building",
    location: "In-Office",
    duration: "90 mins",
    volunteers: "50-100",
    description:
      "Effective resume preparation and skill development are vital for improving interview success rates. This initiative offers targeted workshops.",
    price: "INR 600 per volunteer",
    availability: "Available in 7 locations",
  },
  {
    image: "/images/events/art-for-impact.jpg",
    title: "Art for Impact Workshop",
    location: "Virtual",
    duration: "60 mins",
    volunteers: "30-80",
    description:
      "Channel creativity for a cause! Volunteers create digital or physical artwork to support nonprofit campaigns and awareness drives.",
    price: "INR 400 per volunteer",
    availability: "Available in 7 locations",
  },
  {
    image: "/images/events/green-drive.jpg",
    title: "Green Drive: Urban Tree Planting",
    location: "Outdoor",
    duration: "120 mins",
    volunteers: "20-60",
    description:
      "Join hands to plant saplings in city parks and public spaces, increasing urban green cover and community pride.",
    price: "INR 950 per volunteer",
    availability: "Available in 7 locations",
  },
  {
    image: "/images/events/tech-literacy.jpg",
    title: "Tech Literacy for Seniors",
    location: "In-Office",
    duration: "90 mins",
    volunteers: "15-40",
    description:
      "Empower senior citizens with essential digital skills in a supportive, hands-on workshop setting.",
    price: "INR 700 per volunteer",
    availability: "Available in 7 locations",
  },
  {
    image: "/images/events/food-distribution.jpg",
    title: "Food Distribution Drive",
    location: "Outdoor",
    duration: "90 mins",
    volunteers: "50-120",
    description:
      "Help package and distribute nutritious meals to underserved communities, reducing food insecurity.",
    price: "INR 800 per volunteer",
    availability: "Available in 7 locations",
  },
  {
    image: "/images/events/wellness-session.jpg",
    title: "Wellness & Mindfulness Session",
    location: "Virtual",
    duration: "60 mins",
    volunteers: "50-200",
    description:
      "Certified instructors lead guided mindfulness and wellness sessions to promote mental health and resilience.",
    price: "INR 350 per volunteer",
    availability: "Available in 7 locations",
  },
  {
    image: "/images/events/library-build.jpg",
    title: "Build a Mini Library",
    location: "In-Office",
    duration: "120 mins",
    volunteers: "30-80",
    description:
      "Assemble and decorate mini library kits for placement in schools and community centers, fostering a love for reading.",
    price: "INR 1250 per volunteer",
    availability: "Available in 7 locations",
  },
];

// (Old flagshipExperiences retained for reference, but not used)
const flagshipExperiences = [
  {
    name: "Seedball Making",
    price: 350,
    desc: "Hands-on kit experience for all ages.",
  },
  {
    name: "Teaching & Learning Aids",
    price: 450,
    desc: "Create educational tools for children.",
  },
  {
    name: "Community Clean-ups",
    price: 300,
    desc: "Join city-wide clean-up drives.",
  },
  {
    name: "Virtual Mentoring",
    price: 150,
    desc: "Mentor youth online from anywhere.",
  },
  // ...add more
];

const formatOptions = [
  {
    title: "In-Office Kits",
    price: 350,
    details: "2–3 hrs • 10+ cities",
    desc: "DIY volunteering kits delivered to your office.",
  },
  {
    title: "Outdoor Engagements",
    price: 300,
    details: "Half/Full day • 12+ cities",
    desc: "Participate in city-wide environmental and social activities.",
  },
  {
    title: "Virtual Volunteering",
    price: 150,
    details: "1–2 hrs • Nationwide",
    desc: "Flexible online volunteering for busy teams.",
  },
];

export default function GIVFPage() {
  const tips = [
    {
      text: "Plan high-impact campaigns 🚀",
      prompt: "Help me plan a high-impact volunteering campaign.",
    },
    {
      text: "Discover top nonprofit partners 🤝",
      prompt: "Show me the best nonprofit partners for my campaign.",
    },
    {
      text: "Get the best event rates 💸",
      prompt:
        "How can I get competitive per-volunteer or per-event rates?",
    },
    {
      text: "Organize around UN days 🌍",
      prompt: "Suggest volunteering initiatives for upcoming UN days.",
    },
    {
      text: "Brainstorm ideas for your org 💡",
      prompt:
        "Brainstorm campaign ideas aligned with my organization's priorities.",
    },
    {
      text: "See CSR benchmarks & best practices 📊",
      prompt:
        "Share CSR benchmarks and best practices from other companies.",
    },
    {
      text: "Curious about industry trends? 🔎",
      prompt: "What are the current trends in corporate volunteering?",
    },
    {
      text: "Need campaign ideas? Ask me! 💬",
      prompt:
        "Give me some unique campaign ideas for employee volunteering.",
    },
    {
      text: "So, where would you like to begin? 👋",
      prompt: "Where should I start with my CSR or volunteering program?",
    },
    {
      text: "Want UN day campaign ideas?",
      prompt:
        "Suggest campaign ideas for upcoming UN international days.",
    },
    {
      text: "Explore what’s working in your industry!",
      prompt:
        "What volunteering programs are working well in my industry?",
    },
  ];
  const [tipIndex, setTipIndex] = React.useState(() =>
    Math.floor(Math.random() * tips.length)
  );
  React.useEffect(() => {
    const interval = setInterval(() => {
      setTipIndex((prev) => (prev + 1) % tips.length);
    }, 10000);
    return () => clearInterval(interval);
  }, [tips.length]);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [initialPrompt, setInitialPrompt] = useState("");
  return (
    <>
      <SEO
        title="Great Indian Volunteering Festival (GIVF) - CauseConnect"
        description="Join India's Biggest Volunteering Movement with GIVF. Discover and book CSR & volunteering campaigns across 16+ cities, powered by CORAA AI."
      />
      <Helmet>
        <title>
          GIVF 2025 - Great Indian Volunteering Festival | CauseConnect
        </title>
      </Helmet>
      <main className="bg-white text-gray-900">
        <GIVFHeroSection />
        <MeetCoraaSection 
          dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          setInitialPrompt={setInitialPrompt}
        />
        <PlanCampaignSection />
        <EventCarouselSection />
        <PartnerLogosSection />
      </main>
      <Footer profile={undefined} session={undefined} />
      <CookieConsent />
      {/* Floating CORAA mascot chat button with speech tip */}
      {!dialogOpen && (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end">
          {/* Speech bubble */}
          <div className="mb-2 animate-fade-in-up">
            <div className="bg-white text-gray-800 px-4 py-2 rounded-2xl shadow-lg text-sm font-semibold relative">
              {tips[tipIndex].text}
              <span className="absolute -bottom-2 right-4 w-3 h-3 bg-white rotate-45"></span>
            </div>
          </div>
          <button
            onClick={() => {
              setInitialPrompt(tips[tipIndex].prompt);
              setDialogOpen(true);
            }}
            aria-label="Open CORAA Chat"
            className="group"
          >
            <img
              src="/images/coraa-mascot.png"
              alt="Ask CORAA"
              className="w-16 h-16 rounded-full border-4 border-[#e0f2f1] shadow-lg transition-transform hover:scale-110"
            />
          </button>
        </div>
      )}


      <CoraaAIDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        initialInput={initialPrompt}
      />
    </>
  );
}

// Helper components
function FeatureCard({ icon, title }) {
  return (
    <div className="flex flex-col items-center text-center px-4">
      <div className="text-3xl mb-2">{icon}</div>
      <div className="font-medium text-base text-gray-800">{title}</div>
    </div>
  );
}

function OverviewPillar({ icon, title, desc }) {
  return (
    <div className="flex flex-col items-center bg-white rounded-lg shadow p-6">
      <div className="text-3xl mb-2">{icon}</div>
      <div className="font-semibold text-lg mb-1">{title}</div>
      <div className="text-gray-700 text-sm text-center">{desc}</div>
    </div>
  );
}

// --- HorizontalEventCarousel Component ---
function HorizontalEventCarousel({ events }) {
  // Set cardWidth and visibleCount so 3 cards are always visible
  const cardWidth = 340; // px (includes margin)
  const visibleCount = 3;
  const containerWidth = cardWidth * visibleCount;
  // Duplicate the events so the scroll can loop seamlessly
  const allEvents = [...events, ...events];
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    let animationFrame;
    let start;
    let scrollLeft = 0;
    const totalWidth = cardWidth * events.length;

    function step(timestamp) {
      if (!start) start = timestamp;
      const elapsed = timestamp - start;
      // Scroll speed: 40px/sec
      scrollLeft = (elapsed * 0.04) % totalWidth;
      container.scrollLeft = scrollLeft;
      animationFrame = requestAnimationFrame(step);
    }
    animationFrame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(animationFrame);
  }, [events]);

  return (
    <div
      ref={containerRef}
      style={{
        width: containerWidth,
        overflow: "hidden",
        height: 260,
        margin: "0 auto",
      }}
      className="relative"
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: allEvents.length * cardWidth,
        }}
      >
        {allEvents.map((event, i) => (
          <div
            key={i}
            className="bg-white rounded-2xl shadow-md border border-gray-100 flex flex-col overflow-hidden mx-2 hover:shadow-2xl transition-shadow duration-200"
            style={{ background: "#f8fafc", minWidth: 320, maxWidth: 340 }}
          >
            <img
              src={event.image}
              alt={event.title}
              className="h-32 w-full object-cover rounded-t-2xl"
            />
            <div className="p-4 flex flex-col flex-1">
              <div className="font-extrabold text-lg mb-1 text-gray-900 truncate">
                {event.title}
              </div>
              <div className="flex flex-wrap gap-3 text-xs font-medium text-gray-600 mb-2">
                <span className="inline-flex items-center gap-1 bg-gray-100 px-2 py-1 rounded">
                  <span role="img" aria-label="location">
                    📍
                  </span>
                  {event.location}
                </span>
                <span className="inline-flex items-center gap-1 bg-gray-100 px-2 py-1 rounded">
                  <span role="img" aria-label="duration">
                    ⏱
                  </span>
                  {event.duration}
                </span>
                <span className="inline-flex items-center gap-1 bg-gray-100 px-2 py-1 rounded">
                  <span role="img" aria-label="volunteers">
                    👥
                  </span>
                  {event.volunteers}
                </span>
              </div>
              <div className="text-gray-700 text-sm mb-2 flex-1 line-clamp-3">
                {event.description}
              </div>
              <div className="font-semibold text-primary text-base mb-1">
                {event.price}
              </div>
              <div className="text-xs text-gray-400">{event.availability}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
// --- End VerticalEventCarousel ---
